module.exports = __webpack_public_path__ + "static/img/warning.d39a1125.svg";